import { HelpfulHints } from '../common/HelpfulHints'
import s from '../HelpCenterModal.scss'

const ProposalCreation = () => {
  return (
    <div className={s.container}>
      <div className={s.leftContainer}>
        <iframe
          width="500"
          height="315"
          src="https://www.youtube.com/embed/EsYRmvOPycg"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        />
        <h3 className={s.title}>Expedite Proposal Creation with iDeal CRM</h3>
        <div className={s.content}>
          We all know that pulling together each <b>construction proposal</b> or <b>bid proposal</b>{' '}
          is a time-consuming and sometimes tedious process. And if you are a <b>sub-contractor</b>{' '}
          or a <b>general contractor</b> who bids multiple clients for one opportunity often, things
          get even messier.
          <br />
          <br />
          So today we are going to create a construction proposal faster with the use of
          construction proposal templates and the iDeal CRM Proposal Generator tool.
          <br />
          <br />
          We will:
          <ol className={s.styledList}>
            <li>Enter the Opportunity</li>
            <li>Install or Create Proposal Templates</li>
            <li>Create Proposals</li>
            <li>Email Proposals to Clients</li>
          </ol>
          Watch the video above or download{' '}
          <a
            href="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/Expedite+Proposal+Creation+with+iDeal+CRM.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {' '}
            Expedite Proposal Creation with iDeal CRM
          </a>{' '}
          for step-by-step instructions.
        </div>
      </div>
      <div className={s.rightContainer}>
        <HelpfulHints
          downloadLink="https://ideal-help.s3.us-east-2.amazonaws.com/pdf/Expedite+Proposal+Creation+with+iDeal+CRM.pdf"
          thumbnailUrl="https://ideal-help.s3.us-east-2.amazonaws.com/thumbnails/Expedite+Proposal+Creation+with+iDeal+CRM.jpg"
          text="Expedite Proposal Creation with iDeal CRM"
        />
      </div>
    </div>
  )
}

export default ProposalCreation
